import { AnalysisPregnancyTableItem } from "shared/api/api";

export const SYNC_DATA_ANALYSIS_PREGNANCY = 'SYNC_DATA_ANALYSIS_PREGNANCY';
export interface AnalysisPregnancyState  {
    data?: AnalysisPregnancyTableItem;
    loading: boolean;
}
